import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const VARIANTS = {
  primary:
    'bg-amber text-canvas-black hover:bg-amber-light shadow-[0_8px_24px_-8px_rgba(204,132,0,0.55)] hover:shadow-[0_12px_32px_-8px_rgba(204,132,0,0.7)] ring-1 ring-amber/40',
  secondary:
    'bg-white/5 text-canvas-white hover:bg-white/10 ring-1 ring-white/15 hover:ring-white/25 backdrop-blur',
  ghost:
    'text-canvas-white/80 hover:text-canvas-white',
  light:
    'bg-canvas-black text-canvas-white hover:bg-ink ring-1 ring-canvas-black',
  outline:
    'bg-transparent text-canvas-white ring-1 ring-white/20 hover:ring-white/40 hover:bg-white/5',
};

const SIZES = {
  sm: 'text-[13px] px-4 py-2 rounded-full',
  md: 'text-sm px-5 py-2.5 rounded-full',
  lg: 'text-[15px] px-6 py-3 rounded-full',
};

const Button = ({
  children,
  to,
  href,
  onClick,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  className = '',
  type = 'button',
  ...rest
}) => {
  const styles = `inline-flex items-center justify-center gap-1.5 font-medium tracking-tight transition-all duration-300 ease-out will-change-transform hover:-translate-y-[1px] active:translate-y-0 ${VARIANTS[variant]} ${SIZES[size]} ${className}`;

  const inner = (
    <>
      {children}
      {withArrow && (
        <ArrowRight
          size={size === 'lg' ? 16 : 14}
          className="transition-transform group-hover:translate-x-0.5"
        />
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={`group ${styles}`} {...rest}>
        {inner}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={`group ${styles}`} {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <button onClick={onClick} type={type} className={`group ${styles}`} {...rest}>
      {inner}
    </button>
  );
};

export default Button;
